// extracted by mini-css-extract-plugin
module.exports = {"title__back":"styles_title__back__2ELsX","title__main":"styles_title__main__3_fYO","title__subtitle":"styles_title__subtitle__ZNMGC"};